<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/countries']">Países</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li [hidden]="country.id==null"><a [routerLink]="['/countries', country.id]">{{country.name}}</a></li>
  <li [hidden]="country.id!=null">Nuevo país</li>
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<form #formDetails="ngForm">
  <p-card header="Detalles">
    <div class="p-grid">
      <div class="p-col-3 p-field">
          <label for="iso_code_2">Código ISO 2</label>
          <input name="iso_code_2" type="text" pInputText [(ngModel)]="country.iso_code_2" required />
      </div>
      <div class="p-col-3 p-field">
        <label for="iso_code_3">Código ISO 3</label>
        <input name="iso_code_3" type="text" pInputText [(ngModel)]="country.iso_code_3" required />
      </div>
      <div class="p-col-6 p-field">
          <label for="name">Nombre</label>
          <input name="name" type="text" pInputText [(ngModel)]="country.name" required />
      </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="p-d-flex">
            <p-button label="Borrar" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
        </div>
    </ng-template>
  </p-card>
</form>
